<template lang="pug">
  SspLayout(area="core")
    .row
      .col-md-12
        .panel.panel-default
          .panel-heading
            h3.panel-title Schema Definition
          .panel-body
            PrettyJson.pretty-json(:jsonObject="productMetadata")


</template>

<script>
import Core from '@/service/apis/Core'
import PrettyJson from '@/components/common/PrettyJson'

export default {
  data() {
    return {
      productMetadata: null,
      schemaName: this.$route.params.name
    }
  },
  created() {
    Core.getProductMetadataSchema(this.schemaName)
      .then((resp) => {
        this.productMetadata = resp.data
      })
      .catch((e) => {
        this.$emit('error', e)
      })
  },
  components: {
    PrettyJson
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/core/configuration/productmetadataschema/ViewProductMetadataSchema.vue